import { useGetAllCourierPartnersCachedQuery } from "../../../redux/commonRTK";

// Control Tower / analytics courier list — from the cached courierPartner source
// (the one the admin panel uses), covering BOTH B2C and B2B since CT shows both.
// Used to build the parent-courier filter (deduped by parent).
export default function useGetCourierCached() {
    const requestPayload = {
        andfilter: [
            { field: "is_deleted", operator: "eq", value: '0' },
            { field: "isActive", operator: "eq", value: true },
            { field: "isExternal", operator: "eq", value: false },
        ],
        offset: 0,
        limit: 500,
        skipCount: true,
        includes: "id,name,parent,prozoId,supportedShipmentType",
    }

    return useGetAllCourierPartnersCachedQuery(requestPayload)
}
